import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="inner">
        <div className="column is-logo">
          <a href="../index.html" className="main-logo is-light">
            <div className="logo">
              <svg
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 58.5 66.6"
              >
                <path
                  className="face-1"
                  d="M23.1,55.7l16.1-9.3c0,0,0,0,0,0c1.1-0.7,1.8-1.9,1.8-3.1l0.1-19.1L23.1,34.4V55.7z"
                />
                <path
                  className="face-2"
                  d="M21.3,10L2.9,20.5l18,10.2l18.4-10.5c0,0,0,0-0.1,0l-17.4-10C21.7,10.1,21.5,10.1,21.3,10z"
                />
                <path
                  className="face-3"
                  d="M1.8,46.7L18,56.6c0,0,0,0,0,0c0.3,0.2,0.5,0.3,0.8,0.3V34.5L0,23.8v19.7C0,44.9,0.7,46.1,1.8,46.7z"
                />
                <path
                  className="triangle-1"
                  d="M56.8,30.4l-11.4-6.6l-0.1,19.2l11.5-6.7c1-0.6,1.7-1.7,1.7-2.9C58.5,32.1,57.9,31,56.8,30.4z"
                />
                <path
                  className="triangle-2"
                  d="M0,50.7v12.6c0,1.2,0.6,2.3,1.7,2.9c0.5,0.3,1.1,0.5,1.7,0.5c0.6,0,1.2-0.2,1.7-0.5l10.4-6L0,50.7z"
                />
                <path
                  className="triangle-3"
                  d="M16.4,7L5.1,0.5c-1-0.6-2.3-0.6-3.4,0C0.6,1.1,0,2.2,0,3.4v13.2L16.4,7z"
                />
              </svg>
            </div>
            <div className="text">
              <svg
                width="160"
                height="22"
                viewBox="0 0 160 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="letter t"
                  d="M7.52113 7.98393V5.22393H5.47413V1.93493H1.79413V5.22393H0.161133V7.98393H1.79413V13.1359C1.79413 15.7809 2.55313 17.2069 5.24413 17.2069C6.27913 17.2069 6.85413 17.0919 7.52113 16.9539V14.1939C5.95713 14.1939 5.47413 14.1939 5.47413 12.8599V7.98393H7.52113Z"
                  fill="white"
                />
                <path
                  className="letter h"
                  d="M16.2516 4.85593C14.3656 4.85593 13.2156 5.84493 12.5946 6.92593H12.5486V0.554932H8.86861V16.9999H12.5486V10.1919C12.5486 8.55893 13.5146 7.84593 14.6876 7.84593C16.0216 7.84593 16.5966 8.44393 16.5966 10.2149V16.9999H20.2766V9.04193C20.2766 6.35093 18.7356 4.85593 16.2516 4.85593Z"
                  fill="white"
                />
                <path
                  className="letter r"
                  d="M28.5868 5.01693C27.2988 5.01693 26.2868 5.84493 25.7118 7.15593H25.6658V5.22393H21.9858V16.9999H25.6658V11.5259C25.6658 9.01893 27.6668 7.98393 29.5528 8.32893H29.5988V5.10893C29.1848 5.01693 28.9088 5.01693 28.5868 5.01693Z"
                  fill="white"
                />
                <path
                  className="letter e"
                  d="M36.2469 14.6079C34.9359 14.6079 33.7169 13.7339 33.7169 12.0779H42.1809C42.1809 7.79993 40.1339 4.85593 36.1089 4.85593C32.3599 4.85593 30.0369 7.52393 30.0369 11.1119C30.0369 14.7919 32.4059 17.3679 36.3159 17.3679C39.5129 17.3679 41.3529 15.8039 41.9969 13.4349H38.3399C38.1099 14.0099 37.5119 14.6079 36.2469 14.6079ZM36.1089 7.38593C37.5119 7.38593 38.5009 8.21393 38.5009 9.84693H33.7169C33.7169 8.21393 34.7059 7.38593 36.1089 7.38593Z"
                  fill="white"
                />
                <path
                  className="letter e"
                  d="M49.117 14.6079C47.806 14.6079 46.587 13.7339 46.587 12.0779H55.051C55.051 7.79993 53.004 4.85593 48.979 4.85593C45.23 4.85593 42.907 7.52393 42.907 11.1119C42.907 14.7919 45.276 17.3679 49.186 17.3679C52.383 17.3679 54.223 15.8039 54.867 13.4349H51.21C50.98 14.0099 50.382 14.6079 49.117 14.6079ZM48.979 7.38593C50.382 7.38593 51.371 8.21393 51.371 9.84693H46.587C46.587 8.21393 47.576 7.38593 48.979 7.38593Z"
                  fill="white"
                />
                <path
                  className="letter dot"
                  d="M57.9878 17.2069C59.0688 17.2069 59.9428 16.4479 59.9428 15.2519C59.9428 14.0789 59.0688 13.2969 57.9878 13.2969C56.8838 13.2969 56.0328 14.0789 56.0328 15.2519C56.0328 16.4479 56.8838 17.2069 57.9878 17.2069Z"
                  fill="white"
                />
                <path
                  className="letter j"
                  d="M63.718 3.82093C64.753 3.82093 65.558 3.26893 65.558 2.18793C65.558 1.12993 64.753 0.554932 63.718 0.554932C62.683 0.554932 61.878 1.12993 61.878 2.18793C61.878 3.26893 62.683 3.82093 63.718 3.82093ZM61.878 5.22393V16.7239C61.878 18.0579 61.395 18.0579 59.831 18.0579V20.8179C60.498 20.9559 61.073 21.0709 62.108 21.0709C64.799 21.0709 65.558 19.6449 65.558 16.9999V5.22393H61.878Z"
                  fill="white"
                />
                <path
                  className="letter s"
                  d="M73.1069 9.57093C71.2899 9.17993 70.5539 9.15693 70.5539 8.32893C70.5539 7.75393 71.0829 7.38593 72.1179 7.38593C73.3139 7.38593 73.8199 7.89193 73.9349 8.83493H77.3849C77.2699 6.76493 75.7979 4.85593 72.0259 4.85593C68.7139 4.85593 66.8739 6.48893 66.8739 8.62793C66.8739 11.0889 69.0819 11.8249 71.0829 12.2619C72.9459 12.6759 74.0499 12.8139 74.0499 13.8259C74.0499 14.4929 73.4749 14.8379 72.4399 14.8379C70.9909 14.8379 70.2089 14.2629 70.0939 13.0899H66.6439C66.7589 15.4819 68.3689 17.3679 72.5779 17.3679C75.8439 17.3679 77.7299 16.0109 77.7299 13.5269C77.7299 10.8589 75.4299 10.0769 73.1069 9.57093Z"
                  fill="white"
                />
                <path
                  className="letter j"
                  d="M86.2079 2.99293C86.7369 2.99293 87.3579 2.60193 87.3579 1.88893C87.3579 1.17593 86.7369 0.784931 86.2079 0.784931C85.7019 0.784931 85.0579 1.17593 85.0579 1.88893C85.0579 2.60193 85.7019 2.99293 86.2079 2.99293ZM85.2879 5.26993V17.9889C85.2879 19.3229 84.9199 19.4379 83.3559 19.3229V20.7029C84.0229 20.8869 84.4829 20.9559 85.0579 20.9559C86.6219 20.9559 87.1279 19.7599 87.1279 17.8049V5.26993H85.2879Z"
                  fill="white"
                />
                <path
                  className="letter o"
                  d="M94.9749 17.3219C91.3869 17.3219 89.2249 14.7919 89.2249 11.1349C89.2249 7.47793 91.3869 4.94793 94.9749 4.94793C98.5399 4.94793 100.702 7.47793 100.702 11.1349C100.702 14.7919 98.5399 17.3219 94.9749 17.3219ZM94.9749 15.7119C97.5969 15.7119 98.8619 13.6419 98.8619 11.1349C98.8619 8.62793 97.5969 6.55793 94.9749 6.55793C92.3299 6.55793 91.0649 8.62793 91.0649 11.1349C91.0649 13.6419 92.3299 15.7119 94.9749 15.7119Z"
                  fill="white"
                />
                <path
                  className="letter u"
                  d="M110.334 5.26993V12.5839C110.334 14.4009 108.954 15.7119 106.884 15.7119C105.044 15.7119 104.331 14.5159 104.331 12.9979V5.26993H102.491V13.4579C102.491 16.1489 104.285 17.3219 106.424 17.3219C108.425 17.3219 109.667 16.4249 110.288 15.5969H110.334V16.9999H112.174V5.26993H110.334Z"
                  fill="white"
                />
                <path
                  className="letter r"
                  d="M119.84 4.94793C118.161 4.94793 117.218 6.05193 116.597 7.59293H116.551V5.26993H114.711V16.9999H116.551V10.7439C116.551 8.23693 118.322 6.44293 120.875 6.85693H120.921V5.01693C120.599 4.97093 120.277 4.94793 119.84 4.94793Z"
                  fill="white"
                />
                <path
                  className="letter n"
                  d="M128.345 4.94793C126.344 4.94793 125.102 5.84493 124.481 6.67293H124.435V5.26993H122.595V16.9999H124.435V9.68593C124.435 7.86893 125.815 6.55793 127.885 6.55793C129.725 6.55793 130.438 7.75393 130.438 9.27193V16.9999H132.278V8.81193C132.278 6.12093 130.484 4.94793 128.345 4.94793Z"
                  fill="white"
                />
                <path
                  className="letter e"
                  d="M139.737 15.7119C137.184 15.7119 135.919 13.7339 135.919 11.6179H145.188C145.188 7.45493 143.394 4.94793 139.714 4.94793C136.287 4.94793 134.079 7.22493 134.079 11.1349C134.079 14.8149 136.241 17.3219 139.806 17.3219C142.727 17.3219 144.406 15.5739 145.004 13.3889H143.164C142.957 14.1939 142.083 15.7119 139.737 15.7119ZM139.714 6.55793C141.922 6.55793 143.348 8.12193 143.348 10.0079H135.919C135.919 8.12193 137.506 6.55793 139.714 6.55793Z"
                  fill="white"
                />
                <path
                  className="letter y"
                  d="M156.721 5.26993H154.651L151.27 14.8379H151.224L147.636 5.26993H145.566L150.005 16.0339C150.465 17.1839 149.982 18.1729 149.499 18.7019C148.878 19.3689 148.165 19.4379 147.153 19.3459H146.877V20.7259C147.176 20.8179 147.705 20.9559 148.441 20.9559C150.603 20.9559 151.201 19.2309 151.707 17.9659L156.721 5.26993Z"
                  fill="white"
                />
              </svg>
            </div>
            <span className="copyright">© 2025. All rights reserved.</span>
          </a>
        </div>
        <div className="column is-navigation">
          <div className="column-title">Navigation</div>
          <ul>
            <li>
              <a href="../index.html">Home</a>
            </li>

            <li>
              <a href="../login.html">Login</a>
            </li>
            <li>
              <a href="../join.html" data-router-disabled>
                Join
              </a>
            </li>

            <li>
              <a href="../gift.html" data-router-disabled>
                <span className="icon gift">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="61"
                    height="63.96"
                    viewBox="0 0 61 63.96"
                  >
                    <rect y="19.96" width="61" height="11" fill="#898989" />
                    <path
                      d="M19.77,16H28V9c0-5-9.24-13.34-15.62-6.17S15,16,19.77,16Z"
                      fill="#898989"
                    />
                    <g>
                      <rect
                        x="5.5"
                        y="34.96"
                        width="20.5"
                        height="29"
                        fill="#898989"
                      />
                      <rect
                        x="35"
                        y="34.96"
                        width="20.5"
                        height="29"
                        fill="#898989"
                      />
                    </g>
                    <path
                      d="M41.41,16H33.17V9c0-5,9.24-13.34,15.62-6.17S46.17,16,41.41,16Z"
                      fill="#898989"
                    />
                  </svg>
                </span>{" "}
                Gift the course
              </a>
            </li>
          </ul>
        </div>
        <div className="column is-navigation">
          <div className="column-title">Contact</div>
          <ul>
            <li>
              <a href="mailto:contact@threejs-journey.com" target="_blank">
                <span className="icon email">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.667 2.3335H2.33366C1.69199 2.3335 1.17283 2.8585 1.17283 3.50016L1.16699 10.5002C1.16699 11.1418 1.69199 11.6668 2.33366 11.6668H11.667C12.3087 11.6668 12.8337 11.1418 12.8337 10.5002V3.50016C12.8337 2.8585 12.3087 2.3335 11.667 2.3335ZM11.667 4.66683L7.00033 7.5835L2.33366 4.66683V3.50016L7.00033 6.41683L11.667 3.50016V4.66683Z"
                      fill="#8B8B8B"
                    />
                  </svg>
                </span>
                contact@threejs-journey.com
              </a>
            </li>
            <li>
              <a href="https://twitter.com/bruno_simon" target="_blank">
                <span className="icon twitter">
                  <svg
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.954 2.323C23.069 2.712 22.124 2.977 21.129 3.098C22.143 2.487 22.923 1.524 23.292 0.375C22.341 0.93 21.287 1.334 20.165 1.559C19.269 0.6 17.992 0 16.574 0C13.857 0 11.654 2.203 11.654 4.917C11.654 5.307 11.699 5.682 11.781 6.041C7.691 5.848 4.066 3.884 1.64 0.915C1.213 1.637 0.974 2.476 0.974 3.39C0.974 5.1 1.844 6.603 3.162 7.486C2.355 7.46 1.596 7.238 0.934 6.87V6.931C0.934 9.316 2.627 11.305 4.88 11.758C4.467 11.869 4.031 11.929 3.584 11.929C3.27 11.929 2.969 11.899 2.668 11.843C3.299 13.796 5.113 15.22 7.272 15.26C5.592 16.579 3.463 17.365 1.17 17.365C0.78 17.365 0.391 17.342 0 17.298C2.189 18.692 4.768 19.507 7.557 19.507C16.611 19.507 21.556 12.011 21.556 5.521C21.556 5.312 21.556 5.101 21.541 4.891C22.502 4.202 23.341 3.331 24.001 2.343L23.954 2.323Z"
                      fill="#1DA1F2"
                    />
                  </svg>
                </span>
                bruno_simon
              </a>
            </li>
            <li>
              <a href="../discord.html" data-router-disabled>
                <span className="icon discord">
                  <svg
                    version="1.1"
                    id="Calque_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 175 200"
                  >
                    <path d="M69.4,83.9c-5.7,0-10.2,5-10.2,11.1s4.6,11.1,10.2,11.1c5.7,0,10.2-5,10.2-11.1C79.7,88.9,75.1,83.9,69.4,83.9z M105.9,83.9c-5.7,0-10.2,5-10.2,11.1s4.6,11.1,10.2,11.1c5.7,0,10.2-5,10.2-11.1S111.6,83.9,105.9,83.9z" />
                    <path d="M154.5,0h-134C9.2,0,0,9.2,0,20.6v135.2c0,11.4,9.2,20.6,20.5,20.6h113.4l-5.3-18.5l12.8,11.9l12.1,11.2l21.5,19V20.6C175,9.2,165.8,0,154.5,0z M115.9,130.6c0,0-3.6-4.3-6.6-8.1c13.1-3.7,18.1-11.9,18.1-11.9c-4.1,2.7-8,4.6-11.5,5.9c-5,2.1-9.8,3.5-14.5,4.3c-9.6,1.8-18.4,1.3-25.9-0.1c-5.7-1.1-10.6-2.7-14.7-4.3c-2.3-0.9-4.8-2-7.3-3.4c-0.3-0.2-0.6-0.3-0.9-0.5c-0.2-0.1-0.3-0.2-0.4-0.3c-1.8-1-2.8-1.7-2.8-1.7s4.8,8,17.5,11.8c-3,3.8-6.7,8.3-6.7,8.3c-22.1-0.7-30.5-15.2-30.5-15.2c0-32.2,14.4-58.3,14.4-58.3c14.4-10.8,28.1-10.5,28.1-10.5l1,1.2c-18,5.2-26.3,13.1-26.3,13.1s2.2-1.2,5.9-2.9c10.7-4.7,19.2-6,22.7-6.3c0.6-0.1,1.1-0.2,1.7-0.2c6.1-0.8,13-1,20.2-0.2c9.5,1.1,19.7,3.9,30.1,9.6c0,0-7.9-7.5-24.9-12.7l1.4-1.6c0,0,13.7-0.3,28.1,10.5c0,0,14.4,26.1,14.4,58.3C146.5,115.4,138,129.9,115.9,130.6z" />
                  </svg>
                </span>
                Discord
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/three-js-journey"
                target="_blank"
              >
                <span className="icon linkedin">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.2991 21.3043H17.597V15.5032C17.597 14.1199 17.5689 12.3397 15.6678 12.3397C13.7376 12.3397 13.4428 13.8449 13.4428 15.4011V21.3043H9.74069V9.37506H13.297V11.0011H13.3449C13.8418 10.0636 15.0501 9.07402 16.8553 9.07402C20.6064 9.07402 21.3001 11.5428 21.3001 14.7564V21.3043H21.2991ZM5.55941 7.74276C4.36774 7.74276 3.41044 6.77817 3.41044 5.5917C3.41044 4.40628 4.36878 3.44273 5.55941 3.44273C6.74692 3.44273 7.70943 4.40628 7.70943 5.5917C7.70943 6.77817 6.74588 7.74276 5.55941 7.74276ZM7.41568 21.3043H3.70315V9.37506H7.41568V21.3043ZM23.1512 0H1.8448C0.825006 0 0 0.806255 0 1.80105V23.1991C0 24.195 0.825006 25.0002 1.8448 25.0002H23.1481C24.1668 25.0002 25.0002 24.195 25.0002 23.1991V1.80105C25.0002 0.806255 24.1668 0 23.1481 0H23.1512Z"
                      fill="white"
                    />
                  </svg>
                </span>
                LinkedIn
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@BrunoSimon" target="_blank">
                <span className="icon youtube">
                  <svg
                    width="23"
                    height="16"
                    viewBox="0 0 23 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_2059_5204)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.2805 0.538633C21.254 0.800451 22.0134 1.567 22.2767 2.54591C22.9652 5.33863 22.9204 10.6186 22.2911 13.455C22.0308 14.4339 21.2684 15.1975 20.2949 15.4623C17.5465 16.1459 5.23643 16.0615 2.64712 15.4623C1.6736 15.2005 0.914166 14.4339 0.650895 13.455C0.00139857 10.7932 0.0462414 5.16409 0.63643 2.56045C0.896807 1.58154 1.65913 0.817906 2.63266 0.553178C6.30687 -0.217731 18.9728 0.0309965 20.2805 0.538633ZM9.28676 4.59673L15.1886 8.00037L9.28676 11.404V4.59673Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2059_5204">
                        <rect width="23" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Youtube
              </a>
            </li>
          </ul>
          <div className="column-title">Other</div>
          <ul>
            <li>
              <a
                href="https://mux.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mux (video streaming)
              </a>
            </li>
          </ul>
        </div>
        <div className="column is-legal">
          <div className="column-title">Legal</div>
          <ul>
            <li>
              <a href="../legal-notice.html" data-router-disabled>
                Legal notice
              </a>
            </li>
            <li>
              <a href="../general-conditions.html" data-router-disabled>
                General Conditions of Sale and Use
              </a>
            </li>
            <li>
              <span className="separator"></span>
            </li>
            <li>
              <a href="../legal-notice/fr.html" data-router-disabled>
                Mentions légales (fr)
              </a>
            </li>
            <li>
              <a href="../general-conditions/fr.html" data-router-disabled>
                Conditions Générales de Vente et d'Utilisation (fr)
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
